import { useTimeoutPoll } from '@vueuse/core'

export const ping = () => {
  const { isActive, pause, resume } = useTimeoutPoll(
    async () => {
      await window.axios.request({
        method: 'post',
        url: route('ping'),
        'axios-retry': {
          retries: 0,
        },
      })
    },
    30_000,
    { immediate: true },
  )

  return {
    isActive,
    pause,
    resume,
  }
}
